import request from 'assets/js/http';
export function feedback(data) {
  // 获取sector列表
  let content = `用户名称： ${data.userName} \n反馈内容： ${data.content} \n反馈地址： ${data.url}`;
  return request({
    url: '/feedback/send',
    headers: {
      'content-type': 'application/json'
    },
    method: 'post',
    data: {
      msg_type: 'text',
      content: {
        text: content
      }
    }
  });
}
